import axios from "axios";
import { gql } from "graphql-request";
import { customerServiceV2 } from "../constant/Constants";
import { IdCardType, ProductCardType, Gender } from "../enum/Enum.ts";
import { ServiceGraphql } from "./Graphql";
import Storage from "./Storage";
import { removeAccents } from "../utils/function/Function";


const convertIdType = (idType) => {
  switch (idType) {
    case "cmnd":
      return IdCardType.IDENTIFIED_CARD;
    case "cccd":
      return IdCardType.CITIZEN_IDENTIFIED_CARD;
    default:
      return null;
  }
}

const convertProductCardType = (productType) => {
  switch (productType) {
    case 1:
      return ProductCardType.PREPAID
    case 2:
      return ProductCardType.CREDIT
    default:
      return null;
  }
}

const convertGender = (gender) => {
  switch (removeAccents(gender)) {
    case 'NAM':
      return Gender.MALE;
    case 'NU':
      return Gender.FEMALE;
    default:
      return Gender.OTHER;
  }
}

export const graphCheckNewClient = async (phone, email, idType, idNumber) => {
  const CHECK_NEW_CLIENT = gql`
  mutation CheckNewClient($data: CheckNewClientDto!) {
    CheckNewClient(data: $data) {
      authenType
      customerId
      email
      flag
      otpStatus
      phoneNumber
      userConsumerId
    }
  }
  `;
  let variables =
  {
    "data": {
      "customerType": "WEB",
      "email": email,
      "idCardNumber": idNumber,
      "idCardType": convertIdType(idType),
      "phoneNumber": phone
    }
  };

  const response = await ServiceGraphql.request(CHECK_NEW_CLIENT, variables);
  return response.CheckNewClient;
}

export const graphVerifyOtp = async (otp, customerId) => {
  const VERIFY_OTP = gql`
  mutation OnboardingVerifyOtp($data: VerifyOtpDto!) {
    OnboardingVerifyOtp(data: $data) {
      contractId
      contractPresignedUrl
      contractS3key
      customerId
      customerType
      email
      flag
      lastBackEkyc
      lastFaceEkyc
      lastFrontEkyc
      phoneNumber
    }
  }
  `;
  let variables = {
    "data": {
      "customerId": customerId,
      "otpValue": otp
    }
  };

  const response = await ServiceGraphql.request(VERIFY_OTP, variables);
  return response.OnboardingVerifyOtp;
};

export const graphUploadIdCard = async (customerId, type, image) => {
  const query = "mutation EkycIdCard($customerId: Int!, $ekycType: EkycType!, $file: Upload!) {EkycIdCard(customerId: $customerId, ekycType: $ekycType, file: $file) {\nekycError \nekycRespCode  \nekycType \nresponseData}}";
  const variables = {
    "customerId": customerId,
    "ekycType": type,
    "file": null
  }

  let res;
  let data = new FormData();
  data.append("operations", JSON.stringify({ "query": query, "variables": variables, "operationName": "EkycIdCard" }));
  data.append("map", JSON.stringify({ "0": ["variables.file"] }));
  data.append("0", image);
  try {
    res = await axios.post(customerServiceV2, data, {
      headers: {
        "Content-Type": "multipart/form-data",
        'Authorization': (Storage.getLocalAccessToken() === null)
          ? 'Bearer ' + Storage.getLocalAppToken()
          : Storage.getLocalAccessToken()
      }
    })
  } catch (err) {
    console.log(err);
  }
  return res
};

export const graphUploadFaceImage = async (customerId, image, front) => {
  let res;
  const query = "mutation EkycFaceMatch($customerId: Int!, $face: Upload!, $frontIdCard: Upload!) {EkycFaceMatch(customerId: $customerId, face: $face, frontIdCard: $frontIdCard) {\nekycError \nekycRespCode \nekycType \nresponseData}}";
  const variables = {
    "customerId": customerId,
    "frontIdCard": null,
    "face": null
  }
  let data = new FormData();
  data.append("operations", JSON.stringify({ "query": query, "variables": variables, "operationName": "EkycFaceMatch" }));
  data.append("map", JSON.stringify({ "0": ["variables.frontIdCard"], "1": ["variables.face"] }));
  data.append("0", front);
  data.append("1", image)

  try {
    res = await axios.post(customerServiceV2, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': (Storage.getLocalAccessToken() === null)
          ? 'Bearer ' + Storage.getLocalAppToken()
          : Storage.getLocalAccessToken()
      }
    })
  } catch (err) {
    console.log(err);
  }
  return res;
}

export const graphGetAllProducts = async (param) => {
  const GET_ALL_PRODUCTS = gql`
  query AllProducts($filter: ProductFilter, $options: FilterOptions) {
    AllProducts(filter: $filter, options: $options) {
      items {
        brandName
        cardType
        createAt
        createBy
        description
        id
        isDelete
        liabCode
        name
        pinLength
        productCode
        updateAt
        updateBy
      }
    }
  }
  `
  
  const response = await ServiceGraphql.request(GET_ALL_PRODUCTS, param);
  return response.AllProducts;
}

export const graphGetAllOccupations = async (variables) => {
  const GET_ALL_OCCUPATIONS = gql`
  query AllOccupations($filter: OccupationFilter, $options: FilterOptions) {
    AllOccupations(filter: $filter, options: $options) {
      items {
        description
        id
        isDelete
        occupationName
      }
    }
  }
  `

  const response = await ServiceGraphql.request(GET_ALL_OCCUPATIONS, variables);
  return response.AllOccupations;
}

export const graphGetAllPositions = async (variables) => {
  const GET_ALL_POSITIONS = gql`
  query AllPositions($filter: PositionFilter, $options: FilterOptions) {
    AllPositions(filter: $filter, options: $options) {
      items {
        description
        id
        isDelete
        positionName
      }
    }
  }
  `

  const response = await ServiceGraphql.request(GET_ALL_POSITIONS, variables);
  return response.AllPositions;
}

export const graphUpdateAdditionalInformation = async (
  customerId,
  idCardType,
  idCardNumber,
  customerName,
  gender,
  dob,
  nationality,
  company,
  baseAddress,
  perAddress,
  cardAddress,
  email,
  occupation,
  position,
  salary,
  referenceName,
  referencePhone,
  relationShip,
  referenceNote,
  productCode,
  phone,
  productCardType,
  issueDate,
  issuePlace
) => {
  const UPDATE_ADDITIONAL_INFO = gql`
mutation AdditionalInformation($data: AddCustomerInfoInput!) {
  AdditionalInformation(data: $data) {
    contractId
    contractPresignedUrl
    contractS3Key
    customerId
  }
}
`

  let variables = {
    "data": {
      "baseAddress": baseAddress,
      "cardAddress": cardAddress,
      "company": company,
      "customerId": customerId,
      "customerName": customerName,
      "customerReference": {
        "referenceName": referenceName,
        "referenceNote": referenceNote,
        "referencePhone": referencePhone,
        "relationShip": relationShip
      },
      "dob": dob,
      "gender": convertGender(gender),
      "email": email,
      "idCardNumber": idCardNumber,
      "issueDate": issueDate,
      "idCardType": convertIdType(idCardType),
      "issuePlace": issuePlace,
      "nationality": 'Việt Nam',
      "occupationId": parseInt(occupation),
      "perAddress": perAddress,
      "productCardType": convertProductCardType(productCardType),
      "productCode": productCode,
      "salary": parseInt(salary),
      "positionId": parseInt(position)
    }
  };

  const response = await ServiceGraphql.request(UPDATE_ADDITIONAL_INFO, variables);
  return response.AdditionalInformation;
}

export const graphCreateContract = async (contractId) => {
  const CREATE_CONTRACT = gql`
  mutation CreateContract($contractId: Int!) {
    CreateContract(contractId: $contractId)
  }
  `

  const variables = {
    "contractId": contractId
  }

  const response = await ServiceGraphql.request(CREATE_CONTRACT, variables);
  return response.CreateContract;
}

export const graphUpdateEkycFlag = async (customerId) => {
  const UPDATE_EKYC_FLAG = gql`
  mutation UpdateEkycFlag($customerId: Int!) {
    UpdateEkycFlag(customerId: $customerId) {
      customerName
      email
      id
      perAddress
      phoneNumber
    }
  }
  `

  const variables = {
    "customerId": customerId
  };

  const response = await ServiceGraphql.request(UPDATE_EKYC_FLAG, variables);
  return response.UpdateEkycFlag;
}